module.exports = __webpack_public_path__ + "02_bob_beige.c46f0d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_bob_beige.png
// module id = wVTV
// module chunks = 0